import PropTypes from 'prop-types';

export default function OutlineNav(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="M8 5h9M8 10h9M8 15h9M3.5 5h.008M3.5 10h.008M3.5 15h.008"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineNav.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
